import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { fipay, menu, x_alt } from "../../../public/assets";
import { NavbarContainer } from "./Navbar.styled";
import { navLinks, NavIcon } from "../../constants";
import { useTranslation } from "react-i18next";
import Translator from "../Translate";
import JoinWailist from "../JoinWaitlist/JoinWaitlist.component";
import ConfettiPage from "../ConfettiPage/ConfettiPage.component";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { selectLocale } from "../../locales/localeSlice";
import ProductDropDownComponent from "../ProductDropDown/ProductDropDownComponent";
import { MdKeyboardArrowDown } from "react-icons/md";

const Navbar = () => {
  const { t } = useTranslation();
  const currentLocale = useSelector(selectLocale);

  const [status, setStatus] = useState(false);
  const [toggle] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showWailist, setShowWaitlist] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [showProductDropDown, setShowProductDropDown] = useState(false);
  const navigate = useNavigate();

  const toHomePage: () => void = () => {
    navigate("/");
  };

  const handleOpenMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  const handleJoinWaitList = () => {
    setShowWaitlist(true);
  };

  const handleConfetti = () => {
    setShowWaitlist(false);
    setShowConfetti(true);
  };

  const handleCloseCofetti = () => {
    setShowConfetti(false);
  };

  const closeJoinWaitlist = () => {
    setShowWaitlist(false);
  };
  const handleProductClick = () => {
    setShowProductDropDown(!showProductDropDown);
  };

  useEffect(() => {
    const navbar = document.querySelector(".navbar") as HTMLElement | null;

    if (navbar) {
      setTimeout(() => {
        navbar.classList.add("slide-out");
      });
    }
  }, []);

  return (
    <NavbarContainer className="navbar">
      <img
        onClick={toHomePage}
        src="/assets/icons/fipay.svg"
        alt="fipay"
        className="fipay_img"
      />
      {showWailist ? (
        <JoinWailist
          closeModal={() => setShowWaitlist(false)}
          showCongrats={showConfetti}
          handleClick={handleConfetti}
          handleCloseJoinWaitList={closeJoinWaitlist}
        />
      ) : null}
      {showConfetti === true ? (
        <ConfettiPage handleCloseCofetti={handleCloseCofetti} />
      ) : null}
      <ul className="ul-nav">
        {navLinks.map((nav) => (
          <li key={nav.title}>
            <Link
              to={
                nav.title === "Products"
                  ? `${nav.url || ""}`
                  : `/${nav.url || ""}`
              }
              onClick={
                nav.title === "Products" ? handleProductClick : undefined
              }
              style={{ position: "relative" }}
            >
              {t(nav.title, { lng: currentLocale })}

              {nav.title === "Products" && showProductDropDown && (
                <ProductDropDownComponent
                  setShowDiv={setShowProductDropDown}
                  showDiv={showProductDropDown}
                />
              )}
              {nav.title === "Products" && <MdKeyboardArrowDown />}
            </Link>
          </li>
        ))}
      </ul>

      {/* mobile_screen */}

      <div className="mobile_small_screen">
        <div className="menu-button">
          {toggle && (
            <img
              src="/assets/icons/menu01.png"
              alt="menu"
              onClick={handleOpenMenu}
            />
          )}
        </div>

        {isMenuOpen && (
          <div
            style={
              isMenuOpen
                ? {
                    width: "100%",
                    background:
                      "linear-gradient(107.42deg, #FFFFEA 0%, #F3F2F1 42.92%, #DCEBFF 100%)",
                    position: "fixed",
                    top: "-2px",
                    left: "0px",
                    zIndex: "300",
                    height: "100vh",
                  }
                : { display: "none" }
            }
          >
            <div
              style={{
                width: "100%",
                height: "100px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <img
                src="/assets/icons/fipay.svg"
                alt="fipay"
                width={80}
                style={{ margin: "20px" }}
              />
              <TransContainerMobile>
                <Translator />
              </TransContainerMobile>
              <img
                onClick={handleCloseMenu}
                src="/assets/svg/x-alt.svg"
                alt="/assets/svg/x-alt.svg"
                style={{ margin: "20px" }}
              />
            </div>

            <div
              style={{
                height: "auto",
                width: "100%",
              }}
            >
              <ul>
                {navLinks.map((nav, index) => (
                  <li
                    className="mobile-list-nav"
                    key={nav.id}
                    onClick={
                      nav.title === "Products" ? handleProductClick : undefined
                    }
                  >
                    <Link
                      to={nav.title === "Products" ? "#" : `/${nav.url}`}
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {t(nav.title, { lng: currentLocale })}
                      {nav.title === "Products" && showProductDropDown && (
                        <ProductDropDownComponent
                          setShowDiv={setShowProductDropDown}
                          showDiv={showProductDropDown}
                        />
                      )}
                      {nav.title === "Products" && <MdKeyboardArrowDown />}
                    </Link>

                    {/* {index === 0 ? (
                      <p className="Products">
                        {nav.title}
                        <FaChevronDown className="arrow" />
                      </p>
                    ) : (
                     
                    )} */}
                  </li>
                ))}
              </ul>
            </div>
            <button className="join_waitList" onClick={handleJoinWaitList}>
              {t("Join Waitlist", { lng: currentLocale })}
            </button>
          </div>
        )}
      </div>

      <div className="tab_screen">
        <div className="menu-button">
          {toggle && (
            <img
              src="/assets/icons/menu01.png"
              alt="menu"
              onClick={handleOpenMenu}
            />
          )}
        </div>

        {isMenuOpen && (
          <div
            style={
              isMenuOpen
                ? {
                    width: "100%",
                    background:
                      "linear-gradient(107.42deg, #FFFFEA 0%, #F3F2F1 42.92%, #DCEBFF 100%)",
                    position: "fixed",
                    top: "-2px",
                    left: "0px",
                    zIndex: "300",
                    height: "100vh",
                  }
                : { display: "none" }
            }
          >
            <div
              style={{
                width: "100%",
                height: "100px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <img
                src="/assets/icons/fipay.svg"
                alt="fipay"
                width={80}
                style={{ margin: "20px" }}
              />
              <img
                onClick={handleCloseMenu}
                src="/assets/svg/x-alt.svg"
                alt="/assets/svg/x-alt.svg"
                style={{ margin: "20px" }}
              />
            </div>

            <div
              style={{
                height: "auto",
                width: "100%",
              }}
            >
              <ul>
                {navLinks.map((nav, index) => (
                  <li className="mobile-list-nav" key={nav.id}>
                    <Link
                      to={`#${nav.id}`}
                      onClick={
                        nav.title === "Products"
                          ? handleProductClick
                          : undefined
                      }
                      style={{
                        position: "relative",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {t(nav.title, { lng: currentLocale })}
                      {nav.title === "Products" && showProductDropDown && (
                        <ProductDropDownComponent
                          setShowDiv={setShowProductDropDown}
                          showDiv={showProductDropDown}
                        />
                      )}
                      {nav.title === "Products" && <MdKeyboardArrowDown />}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <button className="join_waitList" onClick={handleJoinWaitList}>
              {t("Join Waitlist", { lng: currentLocale })}
            </button>
          </div>
        )}
      </div>

      <div className="nav_Btn">
        <button className="join_waitList" onClick={handleJoinWaitList}>
          {t("Join Waitlist", { lng: currentLocale })}
        </button>
        <div className="nav_arrow_global">
          <TransContainer>
            <Translator />
          </TransContainer>
        </div>
      </div>
      {status ? (
        <div
          className="open"
          // onMouseEnter={handleMouseEnter}
          // onMouseLeave={handleMouseLeave}
        >
          {NavIcon.map((navIcon, index) => (
            <div className="icon-open">
              <div className="open-div">
                <img
                  key={navIcon.id}
                  src={navIcon.icon}
                  alt={navIcon.id}
                  className="w-124px h-32px"
                  onClick={() => window.open(navIcon.link)}
                />
              </div>
              <div className="navIcon_name">{navIcon.name}</div>
            </div>
          ))}
        </div>
      ) : (
        ""
      )}
    </NavbarContainer>
  );
};

export default Navbar;

const TransContainer = styled.div``;

const TransContainerMobile = styled.div`
  position: absolute;
  right: 14%;
`;
